import React from 'react';
import { Link } from 'react-router-dom';
import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

import place5 from '../../assets/img/place5.jpg';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

const Leaderboards = () => {
  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="media"
    >
      <Helmet>
        <title>Leaderboards - DuskBreakers</title>
        <meta name="description" content="DuskBreakers Leaderboards" />
      </Helmet>

      <section>
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="mb-5">Leaderboards</h1>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row d-flex g-4">
            <div className="col-md-4">
              <div className="card linkcard m-0">
                <Link className="noline" to={`/leaderboards/play-2-mint`}>
                  <LazyLoadImage
                    className="img-fluid"
                    alt="Play 2 Mint Leaderboard"
                    src={place5}
                    effect="opacity"
                  />

                  <div className="card-body">
                    <span>Play 2 Mint</span>
                  </div>
                </Link>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card linkcard m-0">
                <Link className="noline" to={`/leaderboards/the-big-break`}>
                  <LazyLoadImage
                    className="img-fluid"
                    alt="The Big Break Leaderboard"
                    src={place5}
                    effect="opacity"
                  />

                  <div className="card-body">
                    <span>The Big Break</span>
                  </div>
                </Link>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card linkcard m-0">
                <Link className="noline" to={`/leaderboards/the-big-break-top-scores`}>
                  <LazyLoadImage
                    className="img-fluid"
                    alt="The Big Break (Top Scores) Leaderboard"
                    src={place5}
                    effect="opacity"
                  />

                  <div className="card-body">
                    <span>The Big Break (Top Scores)</span>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </m.main>
  );
};

export default Leaderboards;
